var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=ColumnArrow, colour=Primary, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 12.1788,
    cy: 11.5791,
    r: 10.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 12.1788,
    cy: 11.5791,
    r: 9.5,
    fill: "#ECF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_ios",
    d: "M9.68621 18.5L8.32952 17.3463L14.6161 12L8.32952 6.65375L9.68621 5.5L17.3295 12L9.68621 18.5Z",
    fill: "#2F3846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnArrow);
export default __webpack_public_path__ + "static/media/ColumnArrow.017367394962a284b04b77c16d7d966b.svg";
export { ForwardRef as ReactComponent };